import { useTranslation } from "react-i18next";
import { getApiErrorMessage, translateApiMessage } from "../lib/utils";

/**
 * Custom hook to handle API messages with translation
 * @returns {Object} Object with functions to get translated API messages
 */
export const useApiMessages = () => {
  const { t } = useTranslation();

  /**
   * Get translated error message from API error
   * @param {Error} error - The error object from API
   * @param {string} fallbackKey - Translation key for fallback message
   * @returns {string} Translated error message
   */
  const getErrorMessage = (error, fallbackKey = "api.errors.unknownError") => {
    return getApiErrorMessage(error, t, fallbackKey);
  };

  /**
   * Translate an API message string
   * @param {string} message - The message string from API
   * @returns {string} Translated message
   */
  const translateMessage = (message) => {
    return translateApiMessage(message, t);
  };

  return {
    getErrorMessage,
    translateMessage,
    t, // Also expose the translation function for convenience
  };
};

